/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import t from "prop-types";
import { classNames as s } from "@progress/kendo-react-common";
const a = "ActionSheetFooter", e = (o) => /* @__PURE__ */ r.createElement("div", { className: s("k-actionsheet-footer", o.className) }, o.children);
e.propTypes = {
  className: t.string
};
e.displayName = a;
e.propTypes = {
  children: t.any
};
export {
  e as ActionSheetFooter,
  a as footerDisplayName
};
